import HttpData from "@/http/data/http-data";

export interface IUtilityCounterReadingData {
    id: number;

    counter_id?: number;
    counterId?: number;

    building_id?: string;
    buildingId?: string;

    counter_type?: string;
    counterType?: string;

    counter_name?: null|string;
    counterName?: null|string;

    counter_number?: null|string;
    counterNumber?: null|string;

    counter_ean?: null|string;
    counterEan?: null|string;

    date?: string;
    reading_date?: string;
    readingDate?: string;

    value: null|number|string;

    previous_value?: null|number|string;
    previousValue?: null|number|string;

    consumption?: null|number|string;

    inserted_by?: null|string;
    insertedBy?: null|string;

    inserted_at?: null|string;
    insertedAt?: null|string;

    image?: null|string;

    is_latest?: boolean|number|string;
    isLatest?: boolean|number|string;
}

function nullableNumber(value: null|undefined|number|string): null|number {
    if (value === null || value === undefined || value === "") return null;

    const parsedValue = Number(value);

    return Number.isFinite(parsedValue) ? parsedValue : null;
}

function booleanValue(
    value: boolean|number|string|undefined,
    defaultValue: boolean
): boolean {
    if (value === undefined) return defaultValue;
    if (typeof value === "boolean") return value;
    if (typeof value === "number") return value === 1;

    return value === "1" || value.toLowerCase() === "true";
}

export default class UtilityCounterReadingData extends HttpData {
    public id: number;
    public counter_id: number;
    public building_id: string;
    public counter_type: string;
    public counter_name: null|string;
    public counter_number: null|string;
    public counter_ean: null|string;
    public date: string;
    public value: null|number;
    public previous_value: null|number;
    public consumption: null|number;
    public inserted_by: null|string;
    public inserted_at: null|string;
    public image: null|string;
    public is_latest: boolean;

    constructor(data: IUtilityCounterReadingData) {
        super();

        this.id = Number(data.id);
        this.counter_id = Number(data.counter_id ?? data.counterId);
        this.building_id = data.building_id ?? data.buildingId ?? "";
        this.counter_type = data.counter_type ?? data.counterType ?? "";
        this.counter_name = data.counter_name ?? data.counterName ?? null;
        this.counter_number = data.counter_number ?? data.counterNumber ?? null;
        this.counter_ean = data.counter_ean ?? data.counterEan ?? null;
        this.date = data.date ?? data.reading_date ?? data.readingDate ?? "";
        this.value = nullableNumber(data.value);
        this.previous_value = nullableNumber(
            data.previous_value ?? data.previousValue
        );
        this.consumption = nullableNumber(data.consumption);
        this.inserted_by = data.inserted_by ?? data.insertedBy ?? null;
        this.inserted_at = data.inserted_at ?? data.insertedAt ?? null;
        this.image = data.image ?? null;
        this.is_latest = booleanValue(
            data.is_latest ?? data.isLatest,
            true
        );
    }
}